import axios from "axios";

const put = ({ id, status }) => {
  const body = {
    status: status
  };

  return new Promise((resolve, reject) => {
    axios
      .put(`/campaign/api/admin/lucky-draws/${id}/status`, body)
      .then((response) => resolve(response.data))
      .catch((error) => {
        return reject(error.response.data);
      });
  });
};

const changeStatus = {
  put
};

export default changeStatus;
